__turbopack_context__.v({
  "black": "_5ydIHW_black",
  "black100": "_5ydIHW_black100",
  "black1000": "_5ydIHW_black1000",
  "black200": "_5ydIHW_black200",
  "black300": "_5ydIHW_black300",
  "black400": "_5ydIHW_black400",
  "black500": "_5ydIHW_black500",
  "black600": "_5ydIHW_black600",
  "black700": "_5ydIHW_black700",
  "black800": "_5ydIHW_black800",
  "black900": "_5ydIHW_black900",
  "blue200": "_5ydIHW_blue200",
  "blue400": "_5ydIHW_blue400",
  "blue600": "_5ydIHW_blue600",
  "blue800": "_5ydIHW_blue800",
  "blue900": "_5ydIHW_blue900",
  "button": "_5ydIHW_button",
  "container": "_5ydIHW_container",
  "green200": "_5ydIHW_green200",
  "green400": "_5ydIHW_green400",
  "green600": "_5ydIHW_green600",
  "green800": "_5ydIHW_green800",
  "green900": "_5ydIHW_green900",
  "header": "_5ydIHW_header",
  "inverted": "_5ydIHW_inverted",
  "logo": "_5ydIHW_logo",
  "logoAlignCenter": "_5ydIHW_logoAlignCenter",
  "logoAlignCenterMobile": "_5ydIHW_logoAlignCenterMobile",
  "logoAlignRight": "_5ydIHW_logoAlignRight",
  "logoNoPadding": "_5ydIHW_logoNoPadding",
  "noWrapper": "_5ydIHW_noWrapper",
  "pink200": "_5ydIHW_pink200",
  "pink400": "_5ydIHW_pink400",
  "pink600": "_5ydIHW_pink600",
  "pink800": "_5ydIHW_pink800",
  "purple200": "_5ydIHW_purple200",
  "purple400": "_5ydIHW_purple400",
  "purple600": "_5ydIHW_purple600",
  "purple800": "_5ydIHW_purple800",
  "purple900": "_5ydIHW_purple900",
  "red200": "_5ydIHW_red200",
  "red400": "_5ydIHW_red400",
  "red600": "_5ydIHW_red600",
  "red800": "_5ydIHW_red800",
  "red900": "_5ydIHW_red900",
  "sky1000": "_5ydIHW_sky1000",
  "text": "_5ydIHW_text",
  "thing": "_5ydIHW_thing",
  "useCaseLendingRed": "_5ydIHW_useCaseLendingRed",
  "white": "_5ydIHW_white",
  "wrapper": "_5ydIHW_wrapper",
  "yellow200": "_5ydIHW_yellow200",
  "yellow400": "_5ydIHW_yellow400",
  "yellow600": "_5ydIHW_yellow600",
  "yellow800": "_5ydIHW_yellow800",
  "yellow900": "_5ydIHW_yellow900",
});
